import moment from "moment";
import { ExpandableTable } from "../../../components/UniversalTable";
import { defaultTableColumns } from "../../../helpers";
import { BankItem } from "../../../types/verified/bank";
import { toMoney } from "shared/utils";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";

export const BankSourcesTable = ({ income }: { income: BankItem[] }) => {
  return (
    <ExpandableTable
      cellClassName="p-4 pl-0 text-sm self-center"
      headerRowClassName="text-content-300 !font-medium"
      renderExpanded={({ original }) => {
        return (
          <div className="px-6 py-8 bg-background-900">
            <ContentTitle title="Income details" contentClassName="space-y-2">
              {/*
                MIssing: 

                    Income description
                    Next payment date 
            */}
              {/* <KeyValue label="Income description" value="wip: design or be" /> */}

              <KeyValue
                label="Employer name"
                value={original.data.employer.name}
              />
              <KeyValue
                label="Income start date"
                value={moment(original.data.start_date).format("ll")}
              />
              <KeyValue
                label="Income end date"
                value={
                  original.data.end_date
                    ? moment(original.data.end_date).format("ll")
                    : "Present"
                }
              />
              <KeyValue
                label="Pay frequency"
                value={original.data.pay_frequency || "-"}
              />
              <KeyValue
                label="Transaction count"
                value={original.data.transaction_count.toString()}
              />
              <KeyValue
                label="Monthly net income"
                value={toMoney(original.data.net_monthly_income_amount)}
              />
              <KeyValue
                label="Monthly gross income"
                value={toMoney(original.data.gross_monthly_income_amount)}
              />
              <KeyValue
                label="Forecasted monthly income"
                value={toMoney(original.data.forecasted_monthly_income_amount)}
              />

              {/* <KeyValue label="Next payment date" value="wip: be or design" /> */}
            </ContentTitle>
          </div>
        );
      }}
      rows={income.map((item) => {
        return {
          source: item.data.institution_metadata?.name || "",
          dateRange:
            moment(item.data.start_date).format("ll") +
            " - " +
            item.data.end_date
              ? moment(item.data.end_date).format("ll")
              : //  not sure if this is present or not
                "Present",
          grossMonthly: toMoney(item.data.gross_monthly_income.cents / 100),
          netMonthly: toMoney(item.data.net_monthly_income_amount),
          original: item
        };
      })}
      columns={defaultTableColumns}
    />
  );
};
